import { jsx as _jsx } from "preact/jsx-runtime";
import React, { useEffect } from 'react';
import VerticalMenu from 'pathfinder/modules/HaloEffectVerticalModule/components/VerticalMenu';
import { getIconFromNavigationLinkElement, getNavigationLinks, } from 'pathfinder/modules/HaloEffectVerticalModule/helpers/wikiPageElements';
import useDebounceValue from 'pathfinder/modules/HaloEffectVerticalModule/utils/useDebounceValue';
import { trackDisplayHaloEffect, trackHaloEffectClickVertical, } from 'pathfinder/modules/HaloEffectVerticalModule/tracking';
import { verticalType } from 'pathfinder/modules/HaloEffectVerticalModule/consts';
export const HaloEffectVerticalModule = ({ track, wikiVertical, isDarkTheme, isForced, }) => {
    const [menuPosition, setMenuPosition] = React.useState(undefined);
    const [visibleVerticalType, setVisibleVerticalType] = React.useState(null);
    const [menuActive, setMenuActive] = React.useState(false);
    const [mouseOverLink, setMouseOverLink] = React.useState(false);
    const [mouseOverMenu, setMouseOverMenu] = React.useState(false);
    const mouseOver = useDebounceValue(mouseOverLink || mouseOverMenu, 100);
    let timeout = null;
    useEffect(() => {
        if (menuPosition) {
            if (!mouseOver && !timeout) {
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    setMenuPosition(undefined);
                    setVisibleVerticalType(null);
                }, 1000);
            }
        }
        return () => {
            clearTimeout(timeout);
        };
    }, [mouseOver, menuPosition]);
    useEffect(() => {
        document.body.addEventListener('mouseleave', function (event) {
            if (event.clientY <= 0 ||
                event.clientX <= 0 ||
                event.clientX >= window.innerWidth ||
                event.clientY >= window.innerHeight) {
                setMenuPosition(undefined);
                setVisibleVerticalType(null);
            }
        });
        return () => {
            document.body.removeEventListener('mouseleave', () => {
                setMenuPosition(undefined);
                setVisibleVerticalType(null);
            });
        };
    }, []);
    useEffect(() => {
        if (!mouseOver) {
            setMenuPosition(undefined);
            setVisibleVerticalType(null);
        }
    }, [mouseOver]);
    useEffect(() => {
        const unmountFunctions = [];
        initiateStyles();
        const navigationItems = getNavigationLinks();
        const linkElements = [];
        navigationItems.forEach((element) => {
            var _a;
            const href = element.getAttribute('href');
            const linkVerticalType = (_a = href === null || href === void 0 ? void 0 : href.match(/.*\/topics\/(.*)$/)) === null || _a === void 0 ? void 0 : _a[1];
            if (linkVerticalType && !!verticalType[linkVerticalType]) {
                linkElements.push({ type: linkVerticalType, element });
            }
        }, 'navigationItem');
        linkElements.forEach(({ type: linkVerticalType, element: linkElement }) => {
            const newLinkElementClass = `${linkElement.getAttribute('class')} halo-effect-icon ${linkVerticalType === wikiVertical ? 'main-halo-effect-icon' : ''}`;
            linkElement.setAttribute('class', newLinkElementClass);
            const onMoseOverListener = () => onMouseOverNavigationIcon(linkVerticalType, linkElement);
            const onClickListener = () => trackHaloEffectClickVertical(track, linkVerticalType);
            linkElement.addEventListener('mouseover', onMoseOverListener);
            linkElement.addEventListener('click', onClickListener);
            unmountFunctions.push(() => {
                linkElement.removeEventListener('mouseover', onMoseOverListener);
                linkElement.removeEventListener('click', onClickListener);
            });
            return () => unmountFunctions.forEach((unmountFunction) => {
                unmountFunction();
            });
        });
        if (linkElements.length) {
            trackDisplayHaloEffect(track);
        }
    }, []);
    const onMouseOverNavigationIcon = (type, linkElement) => {
        if (visibleVerticalType !== type) {
            const iconElement = getIconFromNavigationLinkElement(linkElement);
            const linkRect = linkElement.getBoundingClientRect();
            const iconRect = iconElement.getBoundingClientRect();
            setMouseOverLink(true);
            setMenuPosition({
                top: iconRect.top + iconRect.height / 2,
                left: linkRect.left + linkRect.width - 18,
            });
            setVisibleVerticalType(type);
            const onMouseLeave = () => {
                linkElement.removeEventListener('mouseleave', onMouseLeave);
                setMouseOverLink(false);
            };
            linkElement.addEventListener('mouseleave', onMouseLeave);
        }
    };
    if (!menuPosition && menuActive) {
        return null;
    }
    return (_jsx(VerticalMenu, { isDarkTheme: isDarkTheme, menuPosition: menuPosition, type: visibleVerticalType, onMouseEnter: () => {
            setMouseOverMenu(true);
        }, onMouseLeave: () => {
            setMouseOverMenu(false);
        }, isForced: isForced, track: track }, void 0));
};
function initiateStyles() {
    const style = document.createElement('style');
    style.innerHTML = `
		.halo-effect-icon:focus .global-navigation__icon, .halo-effect-icon:active .global-navigation__icon {
			border:  2px solid #520044;
		}
	`;
    document.getElementsByTagName('head')[0].appendChild(style);
}
